import http from './http-common';
import { saveAs } from 'file-saver';
import { resolveChannelId } from './menuChannel';

const BASE = '/admin/portal/cart-data';
const MENU_PATH = '/cart-data';

// http-common adds logged_user_id / logged_site_id / auth_token; the backend's menu check also
// needs the page's channel_id (menu_code of the "cart-data" menu).
const withChannel = (params = {}) => ({ ...params, channel_id: resolveChannelId(MENU_PATH) });

const clean = (params = {}) => {
  const out = {};
  Object.keys(params).forEach((k) => {
    const v = params[k];
    if (v !== undefined && v !== null && v !== '') out[k] = v;
  });
  return out;
};

// params: { from, to, period, currency, status, include_samples } (YYYY-MM-DD dates)
export const getSummary = (params) => http.get(`${BASE}/summary`, { params: withChannel(clean(params)) });
export const getTrend = (params) => http.get(`${BASE}/trend`, { params: withChannel(clean(params)) });
// params.by: country | city | device | browser | signup_method | product | item | price_band | promo | carrier
export const getBreakdown = (params) => http.get(`${BASE}/breakdown`, { params: withChannel(clean(params)) });
// params adds: sort, order, page, limit
export const getCustomers = (params) => http.get(`${BASE}/customers`, { params: withChannel(clean(params)) });
export const getCustomerDetail = (key) => http.get(`${BASE}/customers/detail`, { params: withChannel({ key }) });

// The multi-sheet Excel workbook is built server-side so the contact-details permission cannot be bypassed in the browser.
export const downloadExport = async (params) => {
  const res = await http.get(`${BASE}/export`, { params: withChannel(clean(params)), responseType: 'blob' });
  const disposition = (res.headers && res.headers['content-disposition']) || '';
  const match = /filename="?([^";]+)"?/i.exec(disposition);
  saveAs(res.data, match ? match[1] : 'cart-analytics.xlsx');
};

const CartAnalyticsService = { getSummary, getTrend, getBreakdown, getCustomers, getCustomerDetail, downloadExport };
export default CartAnalyticsService;
